<template>
  <div class="mostafeed-area bg-white">
      <div class="box d-flex align-items-center justify-content-around flex-wrap w-100" :class="{ 'box--endowments': isEndowmentsMode }">
        <template v-if="isEndowmentsMode">
           <div class="box__wrapper d-flex flex-column align-items-center justify-content-center">
              <i class="icon-mostafeed" />
              <span class="box__numbers">{{ (data?.number_of_completed_products?.toLocaleString("en-US") ?? '-') }}</span>
              <div class="mb-2 box__text">عدد المشاريع</div>
           </div>
           <div class="box__wrapper d-flex flex-column align-items-center justify-content-center">
               <i class="icon-mostafeed" />
              <span class="box__numbers">{{ (data?.number_of_contributions?.toLocaleString("en-US") ?? '-') }}</span>
              <div class="mb-2 box__text">عدد المساهمات</div>
           </div>
           <div class="box__wrapper d-flex flex-column align-items-center justify-content-center">
              <i class="icon-donation" />
              <div class="box__numbers d-flex">
                {{ data?.amount_of_donations?.toLocaleString("en-US") ?? '-' }}
                <div alt="SAR" class="sar-icon sar-icon__white mt-3" />
              </div>
              <div class="mb-2 box__text">إجمالي مبلغ المساهمات</div>
           </div>
        </template>

        <template v-else>
          <div class="box__wrapper d-flex flex-column align-items-center justify-content-center">
            <i class="icon-mostafeed" />
            <span class="box__numbers" data-cy="number-of-completed-cases">
              {{ isCharityCasesPage ? (data?.number_of_visitors?.toLocaleString("en-US")|| 0) : (data?.number_of_completed_cases?.toLocaleString("en-US") || 0) }}
            </span>
            <div class="mb-2 box__text">{{ isCharityCasesPage ? 'عدد الزيارات' : 'مستفيد' }}</div>
          </div>
          <div class="box__wrapper d-flex flex-column align-items-center justify-content-center">
            <i class="icon-donation" />
            <div class="box__numbers d-flex" data-cy="amount-of-donations">
              {{ data?.amount_of_donations?.toLocaleString("en-US") || 0 }}
              <div  alt="SAR" class="sar-icon sar-icon__white mt-3" /> 
            </div>
            <div class="mb-2 box__text">إجمالي مبلغ المساهمات</div>
          </div>
        </template>
        </div>
  </div>
</template>

<script>
export default {
  name: "mostafeed-section",
  props: {
    data: {},
    isCharityCasesPage: {
      type: Boolean,
      default: false
    },
    isEndowmentsMode: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/abstracts/mixins";
@import "@/styles/components/riyal-logo";


.mostafeed-area {
  padding-top: 40px;
  background-size: 60%;
  direction: rtl;
  .box {
    padding: 1.5rem 1rem 2rem;
    text-align: center;
    background: $color-gradient-primary;
    border-radius: 8px;
    box-shadow: $box-shadow-tile;
    color: white;
    margin: 0 !important;
    
    &--endowments {
      background: $color-gradient-endowments !important;
    }

    &__icon {
      font-size: 64px;
      color: white;
    }
    &__numbers {
      font-size: 40px;
      font-weight: bolder;
    }
    &__text {
      font-size: 24px;
    }
    &__wrapper {
      padding: 0.5rem;
    }
  }
  @include respond('xl') {
    .box {
      &__icon {
        font-size: 30px;
      }
      &__numbers {
        font-size: 24px;
      }
      &__text {
        font-size: 16px;
      }
    }
  }
  @include respond('md') {
    .box {
      flex-direction: column;
      gap: 1rem;
      
      &__wrapper {
        width: 100%;
        padding: 1rem 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}

.icon-donation {
  width: 65px;
  aspect-ratio: 1;
  background: url(#{$static-url}/static/icons/icon-donations-white.svg);
}

.icon-mostafeed {
  width: 65px;
  aspect-ratio: 1;
  background: url(#{$static-url}/static/icons/icon-mostafeed.svg);
}
</style>
